import { useRouter } from "next/router";
import { useLottie } from "lottie-react";
import { classNameGenerator } from "@/utils";
import PaymentFailureAnimation from "@/static/lotties/Alert.json";

import styles from "./PaymentFailurePage.module.scss";
import Button from "@/components/Atoms/Button";
import Typography from "@/foundation/Typography/V2";
import MainTemplate from "@/components/Templates/MainTemplate";

interface PaymentFailurePageProps {}

const PaymentFailurePage: React.FC<PaymentFailurePageProps> = () => {
  const router = useRouter();

  const lottieOptions = {
    animationData: PaymentFailureAnimation,
    loop: false,
  };

  const { View } = useLottie(lottieOptions);

  const handleTryAgainButtonClick = () => {
    router.back();
  };
  const cls = classNameGenerator(styles);

  return (
    <MainTemplate hideRibbon>
      <div className={cls("PaymentFailurePage")}>
        <div className={cls("topSection")}>
          {View}
          <Typography
            variant="paragraph2"
            className={cls("PaymentFailureText")}
          >
            Payment Declined!
          </Typography>
        </div>
        <Button
          variant="primary"
          className={cls("button")}
          onClick={handleTryAgainButtonClick}
        >
          Try again
        </Button>
      </div>
    </MainTemplate>
  );
};

export default PaymentFailurePage;
